/*
*###############################################################################
*Module Name                   : VoucherPurchaseController.js                     #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Friday, October 1st 2021, 3:20:00 pm          #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
const getSupplierDets = async () => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Supplier/select`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

const getLocationDets = async () => {
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}Locations/select`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}


const getVoucherGroup = async () => {
  const authToken = localStorage.getItem("authToken")
  const ApiURL = window.Links.ApiURL
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherGroup/`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}

// Voucher Group save method
const setVoucherSave = async (
  strVoucherCode,
  strVoucherDate,
  strSetupLoc,
  strCompanyCode,
  strSupplier,
  strLocation,
  strRemarks1,
  strRemarks2,
  dbSellingAmount,
  dbGrossAmount,
  dbDiscountPer,
  dbItexAmount,
  dbETaxAmount,
  dbAddAmount,
  dbDedAmount,
  dbNetAmount,
  LogUserType,
  menuCode,
  LogCompanyCode,
  LocationCode,
  Reason,
  VCPODETAILS,
  VoucherPoTaxDet,
  pro,
  strBatchNo
) => {
  var myHeaders = new Headers()
  const authToken = localStorage.getItem("authToken")
  myHeaders.append("Authorization", `Bearer ${authToken}`)
  myHeaders.append("Content-Type", "application/json")

  var raw = JSON.stringify({
    strType: 'VPO',
    strRunNo: strVoucherCode == "" ? "NAN" : strVoucherCode,
    dtTxnDate: strVoucherDate,
    dtTxnTime: strVoucherDate,
    strSetupLoc: strSetupLoc,
    strComCode: strCompanyCode,
    strLocCode: strLocation,
    strSupCode: strSupplier,
    strRef1: strRemarks1,
    strRef2: strRemarks2,
    dbSellingAmount: dbSellingAmount,
    dbGrossAmount: dbGrossAmount,
    dbDiscountPer: dbDiscountPer,
    dbItexAmount: dbItexAmount,
    dbETaxAmount: dbETaxAmount,
    dbAddAmount: dbAddAmount,
    dbDedAmount: dbDedAmount,
    dbNetAmount: dbNetAmount,
    intHedProcess: pro,
    intHedCancelled: 0,
    dtCancellDate: '1900-01-01',
    strCancelldUser: '',
    dbPrintCount: 0,
    intHedFullyUsed: 1,
    intExport: 0,
    strExportBatch: '',
    strCreateBy: LogUserType,
    strMenuCode: menuCode,
    strLoggedCompany: LogCompanyCode,
    strLoggedLocation: LocationCode,
    strReason: Reason,
    VCPODETAILS: VCPODETAILS,
    VCPODETAILSTAX: VoucherPoTaxDet,
    BatchNo: strBatchNo
  })

  const ApiURL = window.Links.ApiURL
  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  }

  var data = [];
  await fetch(`${ApiURL}VoucherPO`, requestOptions)
    .then(response => data = response)
    .catch(error => console.log('error', error))
  return data;
}
const getVoucherPOSearch = async LocationCode => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherPO/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
    })
    .catch(error => console.log("error", error))
  return data
}
const getVoucherPOHeader = async (id, LocationCode) => {
  const ApiURL = window.Links.ApiURL
  const authToken = localStorage.getItem("authToken")
  var data = []
  var success = false
  var requestOptions = {
    method: "GET",
    headers: {
      "Authorization": `Bearer ${authToken}`
    },
    redirect: "follow",
  }
  await fetch(`${ApiURL}VoucherPO/search/${id}/${LocationCode}`, requestOptions)
    .then(response => response.json())
    .then(result => {
      data = result.data
      success = result.success
    })
    .catch(error => console.log("error", error))
  return { data, success }
}
export {
  getLocationDets,
  getSupplierDets,
  getVoucherGroup,
  setVoucherSave,
  getVoucherPOSearch,
  getVoucherPOHeader
}